import React from "react";
import { Route, Redirect } from "react-router-dom";

const CustomerPrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem("token"); // set this at customer login
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/auth/signin-customer" /> // redirect to customer login
        )
      }
    />
  );
};

export default CustomerPrivateRoute;
